import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { sanitizeSeoSectionHtml } from '../../../utils/textUtils';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import s from './Description.scss';

interface DescriptionProps extends WithTranslations {
  templatesStore: TemplatesStore;
}

const DescriptionCmp: React.FC<DescriptionProps> = (props) => {
  const [expanded, setExpanded] = useState(false);
  const {
    templatesStore: { loadedFetchParams, activeCategory, activeSubCategory },
    t,
  } = props;

  const category = activeSubCategory || activeCategory;
  const description = category?.description ?? '';
  const page = loadedFetchParams?.page ?? 1;
  const isFirstPage = page === 1;
  const cleanDescription = useMemo(() => sanitizeSeoSectionHtml(description), [description]);
  const [title, ...content] = cleanDescription.split('\n').filter((i) => !!i.trim());

  if (!isFirstPage || !title || !content.length) {
    return null;
  }

  const btnText = expanded ? t('description.read-less') : t('description.read-more');

  return (
    <div className={s.Description}>
      {title && <h2 className={s.Description__title}>{title?.trim()}</h2>}
      {content.map((i, index) => (
        <p
          key={i}
          className={classNames(s.Description__text, { [s.Description__textVisible]: index < 2 || expanded })}
          dangerouslySetInnerHTML={{ __html: i }}
        />
      ))}

      {content.length > 2 && (
        <button onClick={() => setExpanded(!expanded)} className={s.Description__button}>
          {btnText}
        </button>
      )}
    </div>
  );
};

export const Description = withTranslations(injectStoresV2('templatesStore')(DescriptionCmp));
